import { gql, useApolloClient } from '@apollo/client'
import cx from 'classnames'
import { Field, Form, Formik } from 'formik'
import { navigate } from 'gatsby'
import { useState } from 'react'
import { FaSearch } from 'react-icons/fa'
import SearchResultsModal from './SearchResultsModal'
import urlForItem from './urlForItem'
import {
  AdminSearchQuery,
  AdminSearchQueryVariables,
  AdminSearchQuery_adminSearch,
} from './__generated__/AdminSearchQuery'

const searchQuery = gql`
  query AdminSearchQuery($input: String!) {
    adminSearch(input: $input) {
      input
      assumedInputType
      results {
        __typename

        ... on Kit {
          id
          createdAt
          status
          sku
          registrationInfo {
            firstName
            lastName
            dob
            email
          }
        }

        ... on RecoveryCertificate {
          orderId
        }

        ... on Order {
          id
          paymentStatus
        }

        ... on EmailVerification {
          id
          emailAddress
          expiresAt
          code
        }
      }
    }
  }
`

const UniversalSearch = () => {
  const client = useApolloClient()

  const [isLoading, setIsLoading] = useState(false)
  const [modalResults, setModalResults] = useState<AdminSearchQuery_adminSearch>(null)

  return (
    <>
      <Formik
        initialValues={{ searchTerm: '' }}
        onSubmit={async (values, formik) => {
          try {
            setIsLoading(true)
            const result = await client.query<AdminSearchQuery, AdminSearchQueryVariables>({
              query: searchQuery,
              variables: { input: values.searchTerm },
              fetchPolicy: 'network-only',
            })

            const { results } = result.data.adminSearch || []
            if (results.length === 0) {
              alert(`Nothing found. Assumed input type: ${result.data.adminSearch.assumedInputType}`)
              return
            }

            if (results.length === 1) {
              const url = urlForItem(results[0])
              if (url) {
                await navigate(url)
                formik.resetForm()
                return
              }
            }

            setModalResults(result.data.adminSearch)
            formik.resetForm()
          } finally {
            setIsLoading(false)
          }
        }}
      >
        {({ isSubmitting }) => (
          <Form>
            <div className="field">
              <p
                className={cx('control has-icons-left', {
                  'is-loading': isLoading,
                })}
              >
                <Field
                  name="searchTerm"
                  className="input has-placeholder-darker"
                  style={{ width: '25rem' }}
                  type="text"
                  placeholder="Kit ID / Order ID / DOB (dd/mm/yyyy) / Email"
                />
                <span className="icon is-small is-left">
                  <FaSearch />
                </span>
              </p>
            </div>
          </Form>
        )}
      </Formik>

      {modalResults && <SearchResultsModal adminSearch={modalResults} onRequestClose={() => setModalResults(null)} />}
    </>
  )
}

export default UniversalSearch
